

export function dzs_view_anchorScroll_init(){

  /** @var {HTMLElement} */
  const $MENU_ = document.querySelector('.mcon-mainmenu');
  const scrollPositions = [];


  document.querySelectorAll('section[id]').forEach(section =>{

    scrollPositions.push({
      id: section.getAttribute('id'),
      posY: section.offsetTop
    })
  })


  document.addEventListener('scroll', function(e) {
    const scrollY = window.scrollY;




    scrollPositions.forEach(scrollEl=>{
      if(scrollY>scrollEl.posY - 50){


        $MENU_.querySelectorAll('li').forEach(el=>{
          el.classList.remove('active');
        })

        $MENU_.querySelector('a[href="#'+scrollEl.id+'"]').parentElement.classList.add('active');
      }
    })
  });

  document.querySelectorAll('a[href*="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      document.querySelector(this.getAttribute('href')).scrollIntoView({
        behavior: 'smooth'
      });
    });
  });
}
